import React from 'react'
import LogoImage from '../../assets/image/Logo.png'
import IphoneImage from '../../assets/image/app-store-play-logo.svg'
import GoogleplayImage from '../../assets/image/google-play-logo.png'
import { Link, useLocation} from 'react-router-dom'
import SubscribeForm from '../subscribe/SubscribeForm.js'

function Footer() {
const POPPIN_JOB_BASE_URL= process.env.REACT_APP_POPPIN_JOB_BASE_URL;
const url_Path=useLocation();

const openAppStore = () => {
  window.open(process.env.REACT_APP_STORE_URL, '_blank');
};

const openGooglePlay = () => {
  window.open(process.env.REACT_APP_GOOGLE_PLAY_URL, '_blank');
};

  return (
    <>
   {(url_Path.pathname==="/" || url_Path.pathname==="/home" ) && <SubscribeForm/>}
      <div className='builder-footer footer-outer-section'>

        <div className="container">
          <div className="row gy-3">
            <div className="col-lg-6 col-md-12 col-12 text-sm-center text-md-start">
              <div className="foot-f text-center mx-auto mx-sm-auto mx-md-start">
                <img src={LogoImage} alt="logo" className='footer-app-logo'/>
                <div className="mt-4 justify-content-center row">
                  <div className="col-lg-12 col-auto">
                    <select className="form-select" name="country">
                      <option>United States</option>
                      <option>Australia</option>
                      <option>Brazil</option>
                      <option>Canada</option>
                      <option>China</option>
                      <option>France</option>
                      <option>Germany</option>
                      <option>India</option>
                      <option>Ireland</option>
                      <option>Italy</option>
                    </select>
                  </div>
                </div>

                <div className="social-icon mt-3">
                  <Link to="https://www.linkedin.com/company/poppinjobs" target="_blank"><i className="fa-brands fa-linkedin"></i></Link>
                  <Link to="https://www.youtube.com/@PoppinJobs" target="_blank"><i className="fa-brands fa-youtube"></i></Link>
                  <Link to="https://www.instagram.com/poppin_jobs/" target="_blank"><i className="fa-brands fa-instagram"></i></Link>
                  <Link to="http://www.tiktok.com/@poppinjobs" target="_blank"><i className="fa-brands fa-tiktok"></i></Link>
                </div>

                <div className="footer-app-icon mt-4">
                  <img src={IphoneImage} alt="App Store" className='scale-up-animation' onClick={openAppStore}/>
                  <img src={GoogleplayImage} alt="Google Play" className='scale-up-animation' onClick={openGooglePlay} />
                </div>
              </div>
            </div>
            <div className="col-lg-2 col-md-4 col-12 text-center text-sm-center text-md-start">
              <div className="company">
                <h5>Company</h5>
                <ul>
                  <li><Link to={POPPIN_JOB_BASE_URL+"about-us"} target="_blank">About us</Link></li>
                  <li><Link to={POPPIN_JOB_BASE_URL+"blogs"} target="_blank">Blogs</Link></li>
                  <li><Link to={POPPIN_JOB_BASE_URL + "faqs"} target="_blank">FAQ's</Link></li>
                  <li><Link to={POPPIN_JOB_BASE_URL + "contact"} target="_blank">Contact Us</Link></li>
                </ul>
              </div>
            </div>
            <div className="col-lg-2 col-md-4 col-12 text-center text-sm-center text-md-start">
              <div className="services">
                <h5>Services</h5>
                <ul>
                  <li><Link to={POPPIN_JOB_BASE_URL + "user/dashboard"} target="_blank">Browse Jobs</Link></li>
                  <li><Link to={POPPIN_JOB_BASE_URL + "employers"} target="_blank">Employers</Link></li>
                  <li><Link to={POPPIN_JOB_BASE_URL + "jobseekers"} target="_blank">Jobseekers</Link></li>
                  <li><Link to={POPPIN_JOB_BASE_URL + "colleges"} target="_blank">Colleges</Link></li>
                  <li><Link to={POPPIN_JOB_BASE_URL + "hiringMinors"} target="_blank">Hiring Minors</Link></li>
                  {/* <li><Link to={POPPIN_JOB_BASE_URL + "productandfeatures"} target="_blank">Product features</Link></li> */}
                  <li><Link to="resume-builder" target="_blank">Build Your Resume</Link></li>
                </ul>
              </div>
            </div>
            <div className="col-lg-2 col-md-4 col-12 text-center text-sm-center text-md-start">
              <div className="support">
                <h5>Support</h5>
                <ul>
                  <li><Link to={POPPIN_JOB_BASE_URL + "terms-of-service"} target="_blank">Terms of Service</Link></li>
                  <li><Link to={POPPIN_JOB_BASE_URL + "privacy-policy"} target="_blank">Privacy &amp; Policy</Link></li>
                </ul>
              </div>
            </div>
            <div className="copy">
              <h5>Copyright @{new Date().getFullYear()} Poppin' jobs.</h5>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Footer
